<div
  style="width: 100%; height: 100%"
  class="centered"
  [matTooltip]="holiday"
  [matTooltipDisabled]="holiday == undefined"
>
  {{ params.displayName }}
</div>
